import { loyaltyTypesKeys } from '../constants';

export function money(value) {
  return `R$ ${Number(value || 0).toFixed(2).replace('.', ',')}`;
}

export function conditionSummary(program) {
  const config = program.Config || {};

  if (program.Tipo === loyaltyTypesKeys.cashback) {
    if (config.Modo === 'percentual') return `${config.Percentual || 0}% por pedido`;
    if (config.Modo === 'meta_valor') return `A cada ${money(config.ValorMetaAcumulo)} em compras`;
    return `${money(config.ValorFixo)} por pedido`;
  }

  if (program.Tipo === loyaltyTypesKeys.pedidos) {
    return `${config.QuantidadeMeta || 0} pedidos`;
  }

  if (program.Tipo === loyaltyTypesKeys.valor_acumulado) {
    return `${money(config.ValorMeta)} em compras`;
  }

  return '—';
}

export function rewardSummary(program) {
  const reward = program.Recompensa || {};

  if (reward.Tipo === 'cashback') return 'Cashback';
  if (reward.Tipo === 'desconto_fixo') return `${money(reward.Valor)} de desconto`;
  if (reward.Tipo === 'desconto_percentual') return `${reward.Porcentagem || 0}% de desconto`;
  if (reward.Tipo === 'frete_gratis') return 'Frete grátis';

  return '—';
}
